import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import { withTranslation } from 'react-i18next';

class About extends Component {
    render() {
        const { t } = this.props;

        const mission = [t('about.mission1'), t('about.mission2'), t('about.mission3')];
        const activities = [t('about.activity1'), t('about.activity2'), t('about.activity3'), t('about.activity4')];

        return (
            <React.Fragment>
                <PageHelmet 
                    pageTitle={t('about.pageTitle')}
                    description={t('about.metaDescription')}
                    keywords={t('about.metaKeywords')}
                    siteName={t('common.siteName')}
                />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                <main className="about-modern bg_color--1" role="main">
                    <section className="about-hero" aria-label={t('about.pageTitle')}>
                        <div className="container">
                            <div className="row align-items-center row--20">
                                <div className="col-lg-7 col-md-12">
                                    <div className="about-hero-content">
                                        <div className="about-kicker">Na Chansawang</div>
                                        <h1 className="about-title">{t('about.title')}</h1>
                                        <p className="about-lead">{t('about.intro')}</p>
                                        <div className="about-hero-actions">
                                            <a className="btn-default" href="/past-activities">{t('nav.pastActivities')}</a>
                                            <a className="btn-default btn-border" href="/contract">{t('nav.contract')}</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-12">
                                    <div className="about-hero-media">
                                        <img
                                            src="/assets/images/portfolio/portfolio-g.webp"
                                            alt={t('common.logoAlt')}
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="about-section">
                        <div className="container">
                            <div className="about-section-head">
                                <h2 className="about-section-title">{t('about.missionTitle')}</h2>
                            </div>
                            <div className="row row--20 about-card-grid">
                                {mission.map((m, idx) => (
                                    <div className="col-lg-4 col-md-6 col-sm-12 about-card-col" key={idx}>
                                        <article className="about-card">
                                            <div className="about-card-badge">{idx + 1}</div>
                                            <p className="about-card-text">{m}</p>
                                        </article>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="about-section about-split-section">
                        <div className="container">
                            <div className="row align-items-center row--20">
                                <div className="col-lg-6 col-md-12">
                                    <div className="about-split-card">
                                        <h2 className="about-section-title">{t('about.awardTitle')}</h2>
                                        <p className="about-paragraph"><span role="img" aria-label="ถ้วยรางวัล">🏆</span> {t('about.award1')}</p>
                                        <p className="about-paragraph">{t('about.award2')}</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="about-split-card">
                                        <h2 className="about-section-title">{t('about.activityTitle')}</h2>
                                        <ul className="about-list">
                                            {activities.map((a, idx) => (
                                                <li key={idx}>{a}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="about-section">
                        <div className="container">
                            <div className="about-section-head">
                                <h2 className="about-section-title">{t('about.visitorTitle')}</h2>
                            </div>
                            <div className="row row--20 about-quote-grid">
                                <div className="col-lg-6 col-md-12">
                                    <div className="about-quote">
                                        <div className="about-quote-mark">“</div>
                                        <p>{t('about.visitor1')}</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="about-quote">
                                        <div className="about-quote-mark">“</div>
                                        <p>{t('about.visitor2')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="about-section">
                        <div className="container">
                            <div className="about-cta">
                                <h2 className="about-section-title">{t('about.visionTitle')}</h2>
                                <p className="about-paragraph">{t('about.vision')}</p>
                                <h3 className="about-cta-title">{t('about.ctaTitle')}</h3>
                                <p className="about-paragraph">{t('about.cta')}</p>
                                <div className="about-hero-actions">
                                    <a className="btn-default" href="/education">{t('nav.education')}</a>
                                    <a className="btn-default btn-border" href="/contract">{t('nav.contract')}</a>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}


            </React.Fragment>
        )
    }
}
export default withTranslation()(About);
